import type { SignalId } from "@repo/app-types/entities/signal";
import type { FC } from "react";
import { useAllSignalsQuery } from "../../api/entities/signal.js";
import { RemoveFilterChip } from "./filterChip.js";

export interface SignalFilterItemProps {
  value: SignalId | null;
  onChange: (newValue: SignalId | null) => void;
}

export const SignalFilterItem: FC<SignalFilterItemProps> = ({
  value,
  onChange,
}) => {
  const { data: signals } = useAllSignalsQuery();

  if (value === null) {
    return null;
  }

  const signal = signals?.find((s) => s.id === value);

  return (
    <RemoveFilterChip onRemove={() => onChange(null)}>
      <span className="max-w-32 truncate">Signal</span>
      <span>&nbsp;= &quot;{signal?.name ?? value}&quot;</span>
    </RemoveFilterChip>
  );
};
